import { motion, useReducedMotion, useScroll, useTransform } from "motion/react";
import { useRef } from "react";
import { images } from "@/data/resort";
import { ResortLink } from "../resort-button";
import { Eyebrow, MaskReveal, Reveal } from "../reveal";

export function DestinationBridge() {
  const ref = useRef<HTMLElement>(null);
  const reduced = useReducedMotion();
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section
      ref={ref}
      id="destination"
      aria-labelledby="destination-bridge-heading"
      className="relative isolate overflow-hidden bg-primary text-primary-foreground"
    >
      <div className="overlay-forest absolute inset-0 -z-10" />

      <div className="shell py-18 md:py-24">
        <Reveal>
          <Eyebrow tone="light">More Than a Place to Park</Eyebrow>
        </Reveal>
        <h2 id="destination-bridge-heading" className="display-lg mt-6 max-w-[16ch]">
          <MaskReveal>Your Site Is Only</MaskReveal>
          <MaskReveal delay={0.08}>the Beginning</MaskReveal>
        </h2>
        <Reveal delay={0.12}>
          <p className="mt-8 max-w-2xl text-base leading-relaxed text-primary-foreground/80 md:text-lg">
            Settle into Auburn RV Resort and spend your days exploring the American River, historic
            Auburn, Gold Country, Sierra Foothill trails and Northern California destinations.
          </p>
        </Reveal>
        <Reveal delay={0.18}>
          <ResortLink
            variant="onDark"
            href="/nearby-attractions/"
            className="mt-10 w-full sm:w-auto"
          >
            Explore Things to Do
          </ResortLink>
        </Reveal>
      </div>
    </section>
  );
}
